const listeners = new Set();

export function subscribeGroupTripNoticeUnread(listener) {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

export function notifyGroupTripNoticeUnreadChanged() {
  listeners.forEach((listener) => {
    try {
      listener();
    } catch {
      // ignore listener errors
    }
  });
}
